<div style="text-align: center">
  <h2>-- An app built with Nx and xplat --</h2>
  <img width="100" src="assets/nx-logo.png" />
  <span style="position: relative; top: -28px; margin: 10px">+</span>
  <img width="120" src="assets/xplat.png" />
</div>
